import * as tslib_1 from "tslib";
var headersSupported = "Headers" in window;
var globalHeaders = {};
/**
 * A decorator service over fetch that encodes the url and adds global headers on each request.
 * You can set the global headers via AjaxService.configure, e.g.
 *  AjaxService.configure(headers => {
 *      headers["Authorization"] = localStorage.getItem("sbtech_token");
 *      headers["X-Userinfo"] = JSON.stringify({ employeeId: 3 });
 *  });
 * */
var AjaxService = /** @class */ (function () {
    function AjaxService() {
    }
    AjaxService.configure = function (configAction) {
        configAction(globalHeaders);
    };
    /**
     * Sends a request via fetch. The url will be encoded for you so you must not pass an already encoded value.
     * @param url - The non-encoded url.
     * @param options - The request options.
     */
    AjaxService.prototype.send = function (url, options) {
        if (options === void 0) { options = {}; }
        this.addGlobalHeaders(options);
        return fetch(encodeURI(url), options);
    };
    AjaxService.prototype.addGlobalHeaders = function (options) {
        if (headersSupported && options.headers instanceof Headers) {
            throw new Error("send(): headers via Headers class is not supported, use the plain object overload instead");
        }
        else if (Array.isArray(options.headers)) {
            throw new Error("send(): headers via array of string arrays is not supported, use the plain object overload instead");
        }
        options.headers = tslib_1.__assign({}, globalHeaders, options.headers);
    };
    return AjaxService;
}());
export { AjaxService };
//# sourceMappingURL=AjaxService.js.map